function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "monitor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 340",
    d: "M13.95 5.85a.45.45 0 0 1-.45.45h-2.422L9.853 8.751A.45.45 0 0 1 9.45 9h-.032a.45.45 0 0 1-.4-.307l-1.002-3.02L7.151 7.4a.45.45 0 0 1-.777.049L5.608 6.3H4.5a.45.45 0 1 1 0-.9h1.35a.45.45 0 0 1 .374.2l.47.7 1.006-2a.457.457 0 0 1 .435-.246.45.45 0 0 1 .395.308l1.007 3.02.863-1.731a.45.45 0 0 1 .4-.249h2.7a.45.45 0 0 1 .45.448zM18 2.25V14.4a2.25 2.25 0 0 1-2.25 2.25v.225A1.125 1.125 0 0 1 14.625 18h-1.35a1.125 1.125 0 0 1-1.125-1.125v-.225h-6.3v.225A1.125 1.125 0 0 1 4.725 18h-1.35a1.125 1.125 0 0 1-1.125-1.125v-.225A2.25 2.25 0 0 1 0 14.4V2.25A2.25 2.25 0 0 1 2.25 0h13.5A2.25 2.25 0 0 1 18 2.25zM13.5 13.5a.9.9 0 1 0-.9.9.9.9 0 0 0 .9-.9zm2.7 0a.9.9 0 1 0-.9.9.9.9 0 0 0 .9-.9zm0-10.575A1.125 1.125 0 0 0 15.075 1.8H2.925A1.125 1.125 0 0 0 1.8 2.925v7.2a1.125 1.125 0 0 0 1.125 1.125h12.15a1.125 1.125 0 0 0 1.125-1.125z",
    transform: "translate(3 3)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.f2a425b350ab870f16641179db58f7e6.svg";
export { ForwardRef as ReactComponent };